module.exports = __webpack_public_path__ + "static/img/Google.217e37eb.png";